import logo from './logo.svg';
import './App.css';
import MobilePreview from './components/MobilePreview';
import DigitalCard from './components/DigitalCard';
import DigitalPlatinumCard from './components/DigitalPlatinumCard';

function App() {
  return (
    <div className="App">
     {/* <DigitalCard/> */}
<div className=''>
    <DigitalPlatinumCard/>
    </div>
    </div>
  );
}

export default App;
